<template>
  <demo-layout>
    <v-container fluid>
      <v-card>
        <v-card-text>
          <v-alert
            :value="demoCount > 0 && demoCount <= 2"
            type="success">{{ $t('demoWarning', {demoCount: 10 - demoCount }) }}</v-alert>
          <v-alert
            :value="demoCount < 1"
            type="warning">{{ $t('demoEnded') }}</v-alert>
          <v-form
            ref="employeeForm"
            v-model="isFormValid"
            @keyup.native.enter="createEmployee">
            <v-subheader class="v-subheader-margin-left">{{ $t('personalSettings') }}</v-subheader>
            <v-text-field
              v-model="employee.number"
              :error-messages="errorMessages['employee.number']"
              :label="$t('number')"
              class="ml-3"/>
            <v-layout>
              <v-text-field
                v-model="employee.first_name"
                :error-messages="errorMessages['employee.first_name']"
                :label="$t('firstName') + '*'"
                :rules="[$rules.isRequired]"
                class="ml-3"
              />
              <v-text-field
                v-model="employee.last_name"
                :error-messages="errorMessages['employee.last_name']"
                :label="$t('lastName') + '*'"
                :rules="[$rules.isRequired]"
                class="ml-3"
              />
            </v-layout>

          </v-form>

          <employee-settings-schema
            ref="schemaForm"
            :errors="errorMessages"
            :is-employee-data-filled="isFormValid"
            :employee-create="true"
            :is-demo="true"
            :demo-count="demoCount"
            :loading="isLoading"
            @onCreate="createEmployee"
          />
        </v-card-text>
      </v-card>
    </v-container>
  </demo-layout>
</template>

<script>
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import EmployeeSettingsSchema from '@/components/routes/employees/settings/EmployeeSettingsSchema'
import DemoLayout from '@/components/layouts/DemoLayout'
import HelperApi from '@/api/HelperApi'

export default {
  name: 'EmployeeCreate',
  components: { DemoLayout, EmployeeSettingsSchema, EmailInput },
  props: ['dialog'],
  data () {
    return {
      isFormValid: false,
      isLoading: false,
      errorMessages: {},
      employee: {
        number: '',
        first_name: '',
        last_name: ''
      },
      demoCount: null
    }
  },
  methods: {
    async createEmployee (schema, month) {
      const demoLimit = localStorage.getItem('demoCount')

      if (!this.isFormValid) return

      this.isLoading = true
      try {
        month = month.split('-').reverse().join('-')
        const fileName = `${this.employee.number}-${this.employee.last_name}-${this.employee.first_name}`
        await HelperApi.createDemoTimesheet(fileName, { month, employee: this.employee, schema })
        this.$refs.employeeForm.reset()
        this.$refs.schemaForm.clearForm()
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false

      if (demoLimit > 0) {
        localStorage.setItem('demoCount', demoLimit - 1)
        --this.demoCount
      }
    }
  },
  watch: {
    employee: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  i18n: {
    messages: {
      en: {
        cancel: 'Cancel',
        create: 'Save employee',
        firstName: 'First name',
        heading: 'Add a new employee',
        lastName: 'Last name',
        number: 'Employee number',
        personalSettings: 'Personal',
        demoWarning: 'This is a demo. You have already downloaded {demoCount} from 10 possible documents. ',
        demoEnded: 'You have now downloaded 10 documents. Please sign-up.'
      },
      tr: {
        cancel: 'İptal',
        create: 'Çalışanı kaydet',
        firstName: 'İsim',
        heading: 'Yeni çalışan ekle',
        lastName: 'Soyad',
        number: 'Çalışan numarası',
        personalSettings: 'Personel',
        demoWarning: 'Bu bir demodur. Belge indirme limitiniz 10 ve halihazırda {demoCount} belge indirmiş bulunmaktasınız. ',
        demoEnded: '10 Belge indirmiş bulunmaktasınız. Lütfen kaydolun.'
      },
      de: {
        cancel: 'Abbrechen',
        create: 'Speichern',
        firstName: 'Vorname',
        heading: 'Neuer Mitarbeiter',
        lastName: 'Nachname',
        number: 'Mitarbeiternummer',
        personalSettings: 'Pers. Einstellungen',
        demoWarning: 'Dies ist eine Demo. Sie haben schon {demoCount} von 10 möglichen Dokumenten heruntergeladen. ',
        demoEnded: 'Sie haben nun 10 Dokumente heruntergeladen. Melden Sie sich bitte an. '
      },
      ru: {
        cancel: 'Отмена',
        create: 'Создать сотрудника',
        firstName: 'Имя',
        heading: 'Добавить нового сотрудника',
        lastName: 'Фамилия',
        number: 'Номер сотрудника',
        personalSettings: 'Персональные данные',
        demoWarning: 'Это демонстрационная версия. Вы уже загрузили {demoCount} из 10 возможных документов. ',
        demoEnded: 'Вы уже загрузили 10 документов. Пожалуйста, зарегистрируйтесь. '
      }
    }
  },
  mounted () {
    // Localstorage allowed demo generating count
    if (localStorage.getItem('demoCount') === null) localStorage.setItem('demoCount', 10)
    // Assign to local var
    this.demoCount = localStorage.getItem('demoCount')
  }
}
</script>

<style scoped>
  .v-subheader-margin-left {
    margin-left: -1em;
  }
</style>
